import React, { ReactNode } from "react";
import { FunctionComponent, SyntheticEvent, useContext, useEffect, useRef } from "react";

//OpenLayers
import OlOverlay from "ol/Overlay";

//Custom components
import MapContext from "@/components/Map/MapContext";
import { getDefinedOptions, getEvents } from "@/lib/olHelpers";

//Types
import { MapContextType } from "@/@types/context/MapContext";
import { CardPosition } from "@/@types/views/GIS/map";

interface IPopupOverlay {
  id: string
  position?: CardPosition
  onClose: () => void
  autoPan?: boolean
  children: ReactNode
  className?: string
  offset?: number[]
  positioning?: string
}

const PopupOverlay: FunctionComponent<IPopupOverlay> = (props) => {
  const context = useContext(MapContext) as MapContextType;

  const overlayDiv = useRef(null);

  const { className, offset, positioning } = props;

  const DEFAULT_CLASS_NAME = "ol-react-popup";

  const popupClassName = className != undefined ? className : DEFAULT_CLASS_NAME;

  //@ts-ignore TODO:Variable 'overlay' implicitly has type 'any' in some locations where its type cannot be determined
  let overlay = undefined;

  const options = {
    id: undefined,
    element: undefined,
    offset: undefined,
    position: undefined,
    positioning: positioning ? positioning : undefined,
    stopEvent: undefined,
    insertFirst: undefined,
    autoPan: true,
    autoPanAnimation: { duration: 100},
    autoPanMargin: undefined,
    className: undefined
  };

  const events = {
    'change': undefined,
    'change:element': undefined,
    'change:map': undefined,
    'change:offset': undefined,
    'change:position': undefined,
    'change:positioning': undefined,
    'error': undefined,
    'propertychange': undefined
  };

  useEffect(() => {

    let allOptions = Object.assign(options, props);
    //@ts-ignore TODO: Property 'position' does not exist on type 'never'
    allOptions.position = undefined; //we need to set it after adding to map, otherwise autoPan won't work
    let definedOptions = getDefinedOptions(allOptions);

    //definedOptions.element = ReactDOM.findDOMNode(this).querySelector('div');
    //@ts-ignore TODO: Property 'element' does not exist on type 'object'
    definedOptions.element = overlayDiv.current;

    // console.log('options.element', options.element);
    overlay = new OlOverlay(definedOptions);

    if (context.map) {
      const mapOverlay = context.map.getOverlayById(props.id);
      if (mapOverlay) {
        context.map.removeOverlay(mapOverlay);
      }
      context.map.addOverlay(overlay);
      if (props.position) {
        if(offset) {
          overlay.setPosition([props.position[0] + offset[0], props.position[1] + offset[1]]);
        } else {
          //@ts-ignore TODO: Type '"top"' is not assignable to type 'number[] | undefined'
          overlay.setPosition([props.position[0], props.position[1]]);
        }
      }

    } else {
      context.initOptions.overlays.push(overlay);
    }

    let olEvents = getEvents(events, props);
    for(let eventName in olEvents) {
      //@ts-ignore TODO:  Argument of type 'string' is not assignable to parameter of type '("error" | "change" | "propertychange")[]'
      overlay.on(eventName, olEvents[eventName]);
    }

    // console.log('popup overlay: ', context.map, props.position);
  }, [options, events])

  return(
    <div id={"overlay-" + props.id} ref={overlayDiv} className={popupClassName} style={{display: "block",backgroundColor:"rgba(0,0,0,0)",border:"0px",boxShadow:"0 0 0 0"}}>
      <div id="react-popup-content">
        {props.children}
      </div>
    </div>
  );
};

//@ts-ignore TODO: isTouchDevice does not exist on PopupOverlay
PopupOverlay.isTouchDevice = function() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch(e) {
    return false;
  }
}

export default PopupOverlay;

